module.exports = __webpack_public_path__ + "img/offer-hero.9bba2f9f.jpg";